import React from "react";
import { EGIconButton } from "../Button/IconButton/IconButton";
import { Stack } from "@mui/material";
import { TagsPreview } from "./TagsPreview";
/**
 * @returns Icon indicators list
 * @param {indicators} object {key: true || false}
 * @param {entryway} string  "WEBSITE" || "PHONE" || "EMAIL" || "CHAT" || "WHATSAPP" || "APP" || OUTDOOR || "OTHER",
 * @param {classification} string  "type::grievance" || "type::questions" || "type::suggestion"
 * @param {tags} array ["black", "red", "pink", ...etc]
 * @param {transformedType} object contents of the simplified classification label catalog TG-100
 * @param {icon_indicators} determines which icon and text corresponds at indicator
 * @param {t} i18next Corresponds to language selected from I18n
 * @param {theme} MUI theme from MUI
 */

export const IndicatorsList = ({
  indicators = [],
  entryway,
  classification,
  tags = [],
  transformedType = {},
  getLocalizedLabel,
  icon_indicators = {},
  t,
  theme,
  iconSize = 18,
}) => {
  const tagList = Array.isArray(tags) ? tags : [];

  const iconEntryway = {
    WEBSITE: "monitor",
    PHONE: "call",
    EMAIL: "outline_sms",
    CHAT: "outline_messages_3",
    WHATSAPP: "outline_whatsapp",
    APP: "mobile",
    OUTDOOR: "case_manager_icon",
    OTHER: "cd_icon",
  };

  const iconType = {
    GRIEVANCE: "outline_clipboard_tick",
    QUESTION: "outline_archive_book",
    SUGGESTION: "outline_document_like",
    UNKNOWN: "outline_buy_crypto",
  };

  const typeLabels = {
    "type::grievance": "GRIEVANCE",
    "type::questions": "QUESTION",
    "type::suggestion": "SUGGESTION",
  };

  const renderIndicator = ({ key, tooltipText, iconName, iconColor }) => (
    <EGIconButton
      key={key}
      title={tooltipText}
      placement="top"
      iconColorHover="primary"
      iconColor={iconColor}
      iconName={iconName}
      iconSize={iconSize}
    />
  );

  const buildIndicators = () =>
    Object.entries(indicators || {})
      .filter(([key, value]) =>
        key === "confirmed" ? value != null : value === true,
      )
      .map(([key, value]) => {
        if (key === "confirmed") {
          return renderIndicator({
            key,
            tooltipText: t(
              value
                ? "Resolution.case_was_verified"
                : "Resolution.case_was_not_verified",
            ),
            iconName: value ? "bold_verify" : "bold_close",
            iconColor: value ? "success" : "error",
          });
        }
        return renderIndicator({
          key,
          tooltipText: icon_indicators?.[key]?.text || key,
          iconName: icon_indicators?.[key]?.iconName,
        });
      });

  const renderTags = () => (
    <TagsPreview
      tags={tagList}
      transformedType={transformedType}
      getLocalizedLabel={getLocalizedLabel}
      tooltipTitle={t("ReportHeader.classification_tags")}
      iconSize={iconSize}
    />
  );

  const typeLabel = typeLabels[classification] || "GRIEVANCE";

  return (
    <Stack
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexFlow: "row wrap",
        p: "1px 0",
        maxWidth: "100%",
        minWidth: "fit-content",
      }}
      direction="row"
      spacing={0}
    >
      {classification &&
        renderIndicator({
          key: typeLabel,
          tooltipText: t(`ReportsList.types.${typeLabel}`),
          iconName: iconType[typeLabel],
        })}

      {entryway &&
        renderIndicator({
          key: entryway,
          tooltipText: t(`ReportsList.entryways.${entryway}`),
          iconName: iconEntryway[entryway],
        })}

      {buildIndicators()}

      {renderTags()}
    </Stack>
  );
};
